export default "__VITE_ASSET__BJi13Hzm__"